/**
 * Route-level pending fallback, shown while a lazily-loaded page chunk is
 * fetched. Deliberately minimal — a centered branded spinner that fades in
 * after a short delay so fast chunk loads don't flash a loader.
 */
export function PageLoader() {
	return (
		<div className="flex-1 min-h-[50dvh] flex items-center justify-center">
			<div
				className="size-8 rounded-full border-2 border-brand-200 dark:border-brand-900 border-t-brand-600 dark:border-t-brand-400 animate-spin"
				role="status"
				aria-label="Loading"
			/>
		</div>
	);
}
